export const BY_ORDER_REQUEST = 'pdf/BY_ORDER_REQUEST';
export const BY_ORDER_SUCCESS = 'pdf/BY_ORDER_SUCCESS';

export const BY_BOOKING_REQUEST = 'pdf/BY_BOOKING_REQUEST';
export const BY_BOOKING_SUCCESS = 'pdf/BY_BOOKING_SUCCESS';

export const SET_PFD = 'pdf/SET_PDF';
export const CLEAR_PDF = 'pdf/CLEAR_PDF';
